import styled from 'styled-components';
import { DSLink } from '@engenharia/ds-react';

const Image = styled.img`
  width: 173px;
`;

const Link = styled(DSLink)`
  display: ${(props) => (props.fullWidth ? 'block' : 'initial')};
  line-height: ${(props) => (props.fullWidth ? '0' : 'initial')};
`;

export { Image, Link };
